import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import { Modal, Input, Text } from '@bigcommerce/big-design';

const DeleteAddressModal = ({ payload, showDeleteAddressModal, setShowDeleteAddressModal, addressId, deleteLocation, setSubmitted }) => {
  const update = () => {
    deleteLocation(payload, addressId);
    setSubmitted(true);
    setShowDeleteAddressModal(false);
  }

  return(
    <Modal
      actions={[
        {
          text: 'Cancel',
          variant: 'subtle',
          onClick: () => setShowDeleteAddressModal(false),
        },
        { text: 'Remove Address', onClick: () => update() },
      ]}
      closeOnClickOutside={true}
      closeOnEscKey={true}
      header="Remove Address"
      isOpen={showDeleteAddressModal}
      onClose={() => setShowDeleteAddressModal(false)}
    >
      <Text>Are you sure you want to delete this address?</Text>
    </Modal>
  )
}

export default DeleteAddressModal;